export enum enumStatusLoad {
  NOT_STARTED,
  LOADING,
  LOADED,
  ERROR = -1,
}
